import { jsx as p } from "react/jsx-runtime";
import { forwardRef as R, useState as j, useRef as k, useImperativeHandle as w } from "react";
import C from "clsx";
import { useId as c, useTracking as S, getText as q } from "../utils.js";
import { ExpandableContext as A } from "./components/expandable-context.js";
import { ExpandableContent as D } from "./components/expandable-content.js";
import { ExpandableTitle as H } from "./components/expandable-title.js";
import e from "./expandable.module.less.js";
const L = R(
  function({
    className: i,
    variant: d = "blue-yellow",
    defaultOpen: f = !1,
    onChange: t,
    open: m,
    tracking: u = !0,
    ...x
  }, b) {
    const [v, E] = j(f), O = c(), n = k(null), s = m ?? v, o = d.split("-"), y = c(), r = o[0] === "line" ? o : ["fill", ...o], I = S(u), T = (l) => {
      var a;
      E(l), I({
        eventCategory: "expandable",
        eventAction: l ? "open" : "close",
        eventLabel: q(
          (a = n.current) == null ? void 0 : a.querySelector(`.${e.button}`)
        )
      }), t == null || t(l);
    };
    return w(b, () => n.current), /* @__PURE__ */ p(A.Provider, { value: { open: s, setOpen: T, contentId: O, titleId: y }, children: /* @__PURE__ */ p(
      "div",
      {
        ...x,
        className: C(
          e.expandable,
          e[r[0]],
          e[r[1]],
          e[r[2]],
          e[s ? "open" : "closed"],
          i
        ),
        ref: n
      }
    ) });
  }
), K = Object.assign(L, {
  Title: H,
  Content: D
});
export {
  K as Expandable
};
//# sourceMappingURL=expandable.js.map
